import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=6bee0478&lang=pug&"
import script from "./Bubble.vue?vue&type=script&lang=ts&"
export * from "./Bubble.vue?vue&type=script&lang=ts&"
import style0 from "./Bubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports